// Refcounted background scroll-lock buat modal/popup full-screen.
//
// Kenapa ada: `reactjs-popup` prop `lockScroll` cuma efektif kalau `modal` di-set (di app
// ini popup-nya gak pakai `modal`), jadi background tetap ke-scroll di belakang popup.
// PopCheckout malah pakai overlay custom tanpa lock sama sekali. Util ini nyamain perilaku
// lock buat SEMUA popup: kunci scroll <html> + <body> selama minimal satu modal kebuka.
//
// Refcount biar aman kalau popup ke-stack (mis. MSF popup nimpa balance popup) — lock baru
// dilepas pas modal terakhir ditutup, dan style asal dipulihin persis.

let lockCount = 0;
let saved = null;

export function lockBodyScroll() {
  if (lockCount === 0) {
    const html = document.documentElement;
    const body = document.body;
    saved = { html: html.style.overflow, body: body.style.overflow };
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

export function unlockBodyScroll() {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0 && saved) {
    document.documentElement.style.overflow = saved.html;
    document.body.style.overflow = saved.body;
    saved = null;
  }
}
